import React, { useRef, useState } from "react";

// A draggable before/after comparison slider
export function BeforeAfter({ before, after, className = "" }) {
  const [pos, setPos] = useState(50);
  const ref = useRef(null);
  const dragging = useRef(false);

  const move = (clientX) => {
    const rect = ref.current.getBoundingClientRect();
    const p = ((clientX - rect.left) / rect.width) * 100;
    setPos(Math.max(0, Math.min(100, p)));
  };
  const onDown = () => { dragging.current = true; };
  const onUp = () => { dragging.current = false; };
  const onMove = (e) => {
    if (!dragging.current) return;
    move(e.touches ? e.touches[0].clientX : e.clientX);
  };

  return (
    <div
      ref={ref}
      className={`relative overflow-hidden select-none cursor-ew-resize bg-ccpm-stone ${className}`}
      onMouseMove={onMove} onMouseUp={onUp} onMouseLeave={onUp}
      onTouchMove={onMove} onTouchEnd={onUp}
      data-testid="before-after"
    >
      {/* After (full) */}
      <img src={after} alt="After" className="block w-full h-full object-cover pointer-events-none" draggable={false} />
      {/* Before (clipped) */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" style={{ width: `${pos}%` }}>
        <img src={before} alt="Before" className="block h-full max-w-none object-cover" style={{ width: ref.current ? ref.current.offsetWidth : "100%" }} draggable={false} />
      </div>
      {/* Labels */}
      <span className="absolute top-3 left-3 text-[10px] font-semibold uppercase tracking-wider bg-ccpm-charcoal/80 text-ccpm-ivory px-2 py-1">Before</span>
      <span className="absolute top-3 right-3 text-[10px] font-semibold uppercase tracking-wider bg-ccpm-olive/90 text-ccpm-ivory px-2 py-1">After</span>
      {/* Handle */}
      <div className="absolute inset-y-0 -ml-px w-0.5 bg-ccpm-ivory shadow-[0_0_0_1px_rgba(0,0,0,0.1)]" style={{ left: `${pos}%` }}>
        <button
          onMouseDown={onDown} onTouchStart={onDown}
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-ccpm-ivory border border-ccpm-border shadow-lg flex items-center justify-center cursor-ew-resize"
          aria-label="Drag to compare" data-testid="before-after-handle"
        >
          <span className="text-ccpm-olive text-xs">◀▶</span>
        </button>
      </div>
    </div>
  );
}
